"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a contact already exists
 * @param {string} email the email of the contact that already exists
 */
class ContactAlreadyExistsError extends client_library_1.ExtendableError {
    constructor(email) {
        super(`Contact already exists with email: ${email}`);
    }
}
exports.default = ContactAlreadyExistsError;
//# sourceMappingURL=ContactAlreadyExistsError.js.map